import React, {useState, useContext} from 'react';

import './login.css';
import Input from '../../utils/input/Input';
import {VALIDATOR_REQUIRE, VALIDATOR_EMAIL,} from '../../utils/input/validators';
import {useForm} from '../../utils/input/form-hook';
import {AuthContext} from '../../utils/context/auth-context';
import {useHttpClient} from '../../utils/input/http-hook';
import LoadingSpinner from '../../utils/loader/LoadingSpinner';
import ErrorModal from '../../utils/loader/ErrorModal';


const Login = () => {    

    const auth = useContext(AuthContext);  
    const [isLoginMode, setIsLoginMode] = useState(true);
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [formState, inputHandler, setFormData] = useForm(
        {
         email: {
            value: '',
            isValid: false
          },
         password: {
            value: '',
            isValid: false
          }
        },        
        false
      );
    
      const authSubmitHandler = async event => {
        event.preventDefault();
        if (isLoginMode) {
            try {
              const responseData = await sendRequest(
                process.env.REACT_APP_BECKEND_URL +  '/users/login',
                'POST',
                JSON.stringify({
                  email: formState.inputs.email.value,
                  password: formState.inputs.password.value
                }),
                {
                  'Content-Type': 'application/json'
                }
              );
              auth.login(responseData.userId, responseData.token);
            } catch (err) {}
          } 
        // else {
        //     try {
        //         const responseData = await sendRequest(
        //         process.env.REACT_APP_BECKEND_URL + '/users/signup',
        //         'POST',
        //         JSON.stringify({
        //             name: formState.inputs.name.value,
        //             email: formState.inputs.email.value,
        //             password: formState.inputs.password.value
        //         }),
        //         {
        //             'Content-Type': 'application/json'
        //         }
        //         );

        //         auth.login(responseData.user.id);
        //     } catch (err) {}
        //     }  
      };
        
    
       return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError} />
            <section className="section-book">
                    <div className="row">
                        <div className="book">
                        {isLoading && <LoadingSpinner asOverlay />}
                            <div className="book__form">
                            <form className="form" onSubmit={authSubmitHandler}>
                                    <div className="u-margin-bottom-medium">
                                        <h2 className="heading-secondary">
                                            Log In
                                        </h2>
                                    </div>                                

                                    <div className="form__group">
                                        <Input 
                                            id="email"
                                            element="input" 
                                            type="email"
                                            label="Email" 
                                            validators={[VALIDATOR_EMAIL()]} 
                                            // errorText="error"
                                            onInput={inputHandler}
                                        ></Input>                                   
                                    </div>

                                    <div className="form__group">
                                    <Input 
                                            id="password"
                                            element="input" 
                                            type="password"
                                            label="Password" 
                                            validators={[VALIDATOR_REQUIRE()]} 
                                            // errorText="error"
                                            onInput={inputHandler}
                                        ></Input>                                    
                                    </div>

                                    <div className="form__group">
                                        <button className="btn btn--green" type="submit" disabled={!formState.isValid}>Login</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
       )
    };


export default Login;